module.exports = __webpack_public_path__ + "media/images/icons/icon_eye_active-d965e5a7122edf1dbbacfc801e1887ba.svg";